import { DataValidator, IsBoolean, IsNumber, IsString, Required, transformKeys } from "@/utils/type-vaildator";
import api from "./api";

interface ToggleAgentUserStatusResponse {
  message: string;
  agent_id: string;
  user_id: number;
  is_agent: number;
}

export interface UpdateAgentAdminRequest {
  agentId: string,
  userId: string,
  userName: string,
  roleType: number,
  userManagement?: number,
  permissionManagement?: number,
  dataOverviewManagement?: number,
  contentManagement?: number,
  orderManagement?: number,
  companyManagement?: number,
}

export class ToggleAgentUserStatusData {
  status?: number;
}

const transformAndValidateData = (
  response: ToggleAgentUserStatusResponse
): ToggleAgentUserStatusData => {
  const transformedData = transformKeys(response);

  try {
    return DataValidator.validateOrThrow(transformedData, ToggleAgentUserStatusData);
  } catch (error) {
    console.error("AgentUserToggleStatus data validation failed:", error.message);
    throw error;
  }
};

// 更新智能体管理员
export const updateAgentAdmin = async ({
  agentId,
  userId,
  userName,
  roleType,
  userManagement,
  permissionManagement,
  dataOverviewManagement,
  contentManagement,
  orderManagement,
  companyManagement,
}: UpdateAgentAdminRequest) => {
  const res = await api.post<ToggleAgentUserStatusResponse>('/agent-v2/update-agent-user', {
    agent_id: agentId,
    user_id: userId,
    user_name: userName,
    role_type: roleType,
    user_management: userManagement,
    permission_management: permissionManagement,
    data_overview_management: dataOverviewManagement,
    content_management: contentManagement,
    order_management: orderManagement,
    company_management: companyManagement,
  });
  return transformAndValidateData(res.data);
};
